<template lang="pug">
info-card(title='Detalhes da conta bancária', icon='fas fa-university')
  .card-body(slot='card-body', :class='{ hide }')
    div(v-for='info in accountInfo')
      span {{ info.key | bankAccountInfo }}: #[span.text-bold {{ info.value }}]
  .card-footer(slot='card-footer')
    .columns
      .column
        a.btn.btn-link.btn-sm(@click='buttonToogle.action')
          i(:class='buttonToogle.icon')
          |
          | {{ buttonToogle.label }}
      .column.col-auto
        router-link.btn.btn-primary.btn-sm(
          :to='{ name: "balances.current.form-bank-verify" }'
        )
          i.fas.fa-fw.fa-edit
          |
          | Alterar conta bancária
</template>

<script>
export default {
  props: {
    informations: { type: Array, required: true },
  },
  data() {
    return {
      hide: true,
    }
  },
  computed: {
    buttonToogle() {
      if (this.hide)
        return {
          icon: 'fas fa-eye',
          label: 'Exibir',
          action: () => (this.hide = false),
        }
      return {
        icon: 'fas fa-eye-slash',
        label: 'Ocultar',
        action: () => (this.hide = true),
      }
    },
    accountInfo() {
      const whitelist = [
        'account_type',
        'bank',
        'bank_ag',
        'bank_cc',
        'cpf',
        'name',
      ]

      return this.informations.filter(({ key }) => whitelist.includes(key))
    },
  },
}
</script>

<style lang="stylus" scoped>
.card-body
  animation blur .4 ease-in-out
  &.hide
    filter blur(5px)
</style>
